import {styled} from '@mui/material/styles';

export const CompleteMyAddressWrapper = styled('span')({
  color: '#E82026'
});
